// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"121":"c373489c","978":"51b7d629"}[chunkId] + ".css";
};